module.exports = __webpack_public_path__ + "static/image/bg_home@2x.png";